var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('keep-alive',{attrs:{"include":[
      'LocationTable',
      'SubOrdersTableAdmin',
      'SubOrdersTable',
      'UsersTable',
      'OrdersTable',
      'ParentStocks',
      'Stocks',
      'OrdersTableAdmin',
      'ReturnSearchOrder',
      'ReturnTable',
      'TriggersTable',
      'TriggersHistoriesTable',
      'Reception',
      'InventoryTable',
      'InventoryReturnTable',
      'InStoreAppointmentServicesTable',
      'InStoreAppointmentsTable',
      'CarriersTable',
      'EbookingsSettingsTable',
      'deliveryTable',
      'OrdersInStoreTable',
      'OrdersSettingsTable',
      'ReturnSettingsTable',
      'GlobalSearchOrder',
      'ListsTable',
      'RefundTable',
      'DocumentsTable',
    ],"max":"2"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }